import React from 'react';
import { createPortal } from 'react-dom';
import { doc, getDoc } from 'firebase/firestore';
import { updateDoc } from '../../api/FirestoreInterceptor';
import { db } from '../../config-firebase/firebase.js';

export const PdvWaiterCallOverlay = ({
  warningsEnabled,
  pendingWaiterCalls,
  setPendingWaiterCalls,
  pendingPaymentCalls,
  setPendingPaymentCalls,
}) => {
  if (!warningsEnabled || (pendingWaiterCalls.length === 0 && pendingPaymentCalls.length === 0)) {
    return null;
  }

  return createPortal(
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '15px',
        padding: '20px',
      }}
    >
      {/* Chamados de Mesa */}
      {pendingWaiterCalls.map((callReq) => (
        <div
          key={callReq.id}
          style={{
            backgroundColor: '#f44336',
            color: 'white',
            padding: '25px 30px',
            borderRadius: '8px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.5)',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '400px',
            textAlign: 'center',
          }}
        >
          <h3 style={{ margin: '0 0 15px 0', fontSize: '1.5rem' }}>⚠️ Chamado de Mesa</h3>
          <p style={{ margin: '0 0 20px 0', fontSize: '1.2rem' }}>
            O cliente <strong>{callReq.waiterCall?.callerName}</strong> da mesa{' '}
            <strong>{callReq.waiterCall?.tableNumber}</strong> pede a presença do responsável.
          </p>
          <button
            onClick={async () => {
              try {
                setPendingWaiterCalls((prev) => prev.filter((p) => p.id !== callReq.id));
                const docSnap = await getDoc(doc(db, 'requests', callReq.id));
                if (docSnap.exists() && docSnap.data().waiterCall?.active === true) {
                  // Marca popup como dispensado, mas mantém active: true para continuar piscando na tela até abrir e fechar o pedido
                  await updateDoc(doc(db, 'requests', callReq.id), {
                    'waiterCall.popupDismissed': true,
                  });
                }
              } catch (e) {
                console.error('Error fechar chamado', e);
              }
            }}
            style={{
              backgroundColor: 'white',
              color: '#f44336',
              border: 'none',
              padding: '12px',
              borderRadius: '4px',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              cursor: 'pointer',
            }}
          >
            OK
          </button>
        </div>
      ))}

      {/* Chamados de PAGAMENTO */}
      {pendingPaymentCalls.map((payReq) => (
        <div
          key={payReq.id}
          style={{
            backgroundColor: '#ff9800',
            color: 'white',
            padding: '25px 30px',
            borderRadius: '8px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.5)',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '400px',
            textAlign: 'center',
          }}
        >
          <h3 style={{ margin: '0 0 15px 0', fontSize: '1.5rem' }}>💰 Solicitação de Pagamento</h3>
          <p style={{ margin: '0 0 20px 0', fontSize: '1.2rem' }}>
            Dirija-se a mesa <strong>{payReq.paymentCall?.tableNumber}</strong> para finalizar o pagamento.
          </p>
          <button
            onClick={async () => {
              try {
                setPendingPaymentCalls((prev) => prev.filter((p) => p.id !== payReq.id));
                const docSnap = await getDoc(doc(db, 'requests', payReq.id));
                if (docSnap.exists() && docSnap.data().paymentCall?.active === true) {
                  await updateDoc(doc(db, 'requests', payReq.id), {
                    'paymentCall.active': false,
                  });
                }
              } catch (e) {
                console.error('Error fechar chamado pagamento', e);
              }
            }}
            style={{
              backgroundColor: 'white',
              color: '#ff9800',
              border: 'none',
              padding: '12px',
              borderRadius: '4px',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              cursor: 'pointer',
            }}
          >
            OK
          </button>
        </div>
      ))}
    </div>,
    document.body
  );
};

export default PdvWaiterCallOverlay;

